import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { toast } from "react-toastify";
import { eventTracking, MixpanelEvents } from "../../../utils/userTracking";

const pageNameMapping: Record<string, string> = {
  "MTM metrics that matter": "CEDAR_MTM",
};

export const handlePDFDownload = (theme: string) => {
  toast.success("PDF downloading");
  const pageName = document.getElementById("pageTitle")?.innerText || "CEDAR Dashboard";

  const parameters = new URLSearchParams(window.location.search);
  const granularityParam = parameters.get("granularity");
  const modelParam = parameters.get("model");
  const marketParam = parameters.get("market");
  const yrScenarios = parameters.get("yr_scnr_rv");
  const period = parameters.get("period");

  const multipleYrScenarios = yrScenarios?.includes(",");
  const monthPeriod = period?.includes("Month");

  const pdfButton = document.getElementById("data-dictionary-button");

  if (pdfButton) pdfButton.style.display = "none";

  const dashboardDiv: any = document.getElementById("oceDashboard");
  const menuWidth: any = document.getElementById("oce_header")?.offsetWidth;

  const pdfTooltip: any = document.getElementsByClassName("pdf_menu_tooltip")[0];

  dashboardDiv.style.height = "auto";
  // pdfTooltip.style.display = "none";

  let HTML_Width = dashboardDiv.clientWidth;

  if (window.location?.pathname?.includes("mtp_category")) {
    if (monthPeriod || multipleYrScenarios) {
      const pdf_tables = document.getElementsByClassName("pdf_tables")[0];
      pdf_tables?.classList.add("pdf_download");

      const mtp_category_table = document.getElementsByClassName("mtp_category_table")[0];
      mtp_category_table?.classList.add("mtp_category_table");

      const quarter_breakdown = document.getElementsByClassName("quarter_breakdown")[0];
      quarter_breakdown?.classList.add("pdf_download");

      const combinedTables = document.getElementsByClassName("tablescombined")[0];
      combinedTables?.classList.add("pdf_download");

      const table_2 = document.getElementsByClassName("table_2")[0];
      table_2?.classList.add("pdf_download");

      const titles = document.getElementsByClassName("titles")[0];
      titles?.classList.add("pdf_download");

      const tables = document.getElementsByClassName("tables")[0];
      tables?.classList.add("pdf_download");
    }

    const items = document.getElementById("dashboard_items");
    items?.classList.add(`pdf_download`);
    items?.classList.add(`${multipleYrScenarios ? "multiple" : "one_yr_scnr_no_var"}`);
    items?.classList.add(`${monthPeriod ? "month_period" : "quarter_period"}`);

    const db = document.getElementsByClassName("dashboard")[0];
    db?.classList.add(`pdf_download`);
    db?.classList.add(`${multipleYrScenarios ? "multiple" : "one_yr_scnr_no_var"}`);
    db?.classList.add(`${monthPeriod ? "month_period" : "quarter_period"}`);

    const contentWrapper = document.getElementsByClassName("contentWrapper")[0];
    contentWrapper?.classList.add(`pdf_download`);
    contentWrapper?.classList.add(`${multipleYrScenarios ? "multiple" : "one_yr_scnr_no_var"}`);
    contentWrapper?.classList.add(`${monthPeriod ? "month_period" : "quarter_period"}`);

    HTML_Width = dashboardDiv.clientWidth;
  }

  const HTML_Height: number = pageName.includes("MTM") ? dashboardDiv.clientHeight + 150 : dashboardDiv.clientHeight + 70;

  html2canvas(dashboardDiv, {
    backgroundColor: `${theme === "light" ? "#e7ecf0" : "#11202c"}`,
    width: HTML_Width,
    height: HTML_Height,
    scrollX: 0,
    scrollY: -window.scrollY,
    scale: 2,
    logging: false,
    // @ts-ignore
  }).then(function (canvas) {
    const pdfWidth = HTML_Width;
    const pdfHeight = HTML_Height;
    const pdf_name = pageName in pageNameMapping ? pageNameMapping[pageName] : pageName;
    const imgData = canvas.toDataURL("image/jpeg", 2.0);
    const landScape = pdfWidth > pdfHeight ? "l" : "p";
    const pdf = new jsPDF(landScape, "px", [pdfWidth, pdfHeight]);

    const cedarLogo =
      "data:image/png;base64,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";
    const pdfRedirect =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAFKUlEQVRoQ+2ZbUxbVRjHz7m9pS2M9QVDx2aCzoBMoHuFTd10Y5s4YPI6FjeVmSjRmBlNiFnExQ9TwbEYNCZzxDm3yZyM4ZiowDamZpI4siUumWYvOiEBhkBHQaCl555jzqW3tKW09ELv7Qful37ofXl+9//8n/Oc50Ig/8EAAEh0/HLTtspvL4RpIqLs1lGOUSgUgYQGAzk5iOdSGLzI9Pia3A9P/MCqNHpuzMpBZvowoQJC3xFVgItJXr0yf39Ns1KlMaAAYEIJhMKwAAC0IDElpeDA6UalOtyAbKMEMozfOOkJVFa5D0J94giCh7l/6aOp2e9XN7BqTRThOAgg9Anjl1RCQt4njueFAQDGFq9N35RXVtNkGx6kqvg0P8zbX3NBwmDdHoUxwkpVhHJsyNLXUrHnlaGhrn6HV1Bk5KKorRVH66LjTes4+xiBEPrMHFhyySJICjDmJgQOMh0hGCjVEQDZRlFtyfanO9rO0ReqBADYtVqtPruyodH48PJU66AZQ0bhN/3h7sYOJMQcFh6pgIzfa2aMSAgBDMuCEXNfX11Jfnr3n1euekJExy2lEIhhldQz/EEoPSHULpM8A19v7qR5Sb1Cfj1c9vawuecuwzAQY+xUasaRe9wAEoLZMA3TefPqZfPt638AAHhPCEp4hcAcZsPUDMMqARqzAoyQWzVzAzm8c9nC4d7eu7MduJ/7uaXTOMQ9xLCsUwmMENLootiu31tbL39zsGxzyYHjqgitzm4b4RjHoukG8tVLTyaZO27fdJRkoYIEk4tmgtMT3pTAyI7U8w1sz61rbWdKCzOGurr6aGnOKT/5I6vSGIQOwA3kxK61S/q67tyQCIRfyWk6PVP5fZMxzpTi6QnM2ZE6chzi7BuZ6RaL5Z6QhjFJqavyK0418TA2KycXiH8IFyVcIPjFUugAKExBRW0zq9bo5QDxAjHZE+r5ek8leC+55Pl4B2Baszq3/GSD1CBileAhdDqdbmBgYNClA+DvZ3zIlCQliFgIvjTHrkhLW5b/4u760ufzhGXF8cu3NlKBiIXglYhJWLFyR9X5nzuu/HLt1Js5j3kpRowUIDPxBDIuTk4q+KT+4rz7FkTd+Km++cyeZ9O9VdVgg0xDCYS8GJteR9cYlJz5XPGWdz47ZLdaSXtby8W6two3Sg0yDYiJxc6lxPLXCSU24anCosy9VUcIxvCf3863SA0yUwjnbjFh87ZdWe9+fgRzHJAaRKwnBCWEpYJfJ+QCmS0IWRXh67nP3glNaWzqCc9DFkX4/Yxer9dmffTdufEG0LPt8Glsbx225CD8AEOn02lzP22+ZIiNS7QNDU7aT0xRYr0pIZtHKAgEYKE6u/zjg/FPbHlh1NKPGMX4xohuikRAyOYRPrXo07e+9/WhJZuyi0fMvfwsQCSEbCD0wcKwj6MwCWlZxRgh8O9f1103RZ4l1tfuU3KPuAbjhMkpqz1miH3AdPrVjRscO7tAIGRVRACamF4ajeGgp2dY5NZZVkW8pYrTPwFOMUIGRFBG7HwsZEACFCA0VvaZBh0SK3swIEKias0W2JxHiMQjU3/KzSkyp4i/HBH5/1xqkeqX1yf2t9+S6vuIP6F4RR5J316Usbfqi4DGQceKVj040N3d7u8JUv6fsCFvR9a+L6sxh6Y/1zpbujPjv872O0TJMtCOpPj0NuU7wayCZRCHYtdl5q5/bd8HhBC/k0bP7lRstxosoSDBHKeap1X83drkc2QaaoFPeiFiQUINbFqK/A873Kqu/kNf2gAAAABJRU5ErkJggg==";

    const fileName = `${pdf_name}_${marketParam ? marketParam + "_" : ""}${modelParam ? modelParam + "_" : ""}${
      granularityParam ? granularityParam : ""
    }`;

    const pdfButton = document.getElementById("data-dictionary-button");

    pdf.setFontSize(20);
    pdf.setTextColor(0, 160, 221);
    pdf.addImage(imgData, "JPEG", -menuWidth, 0, pdfWidth + menuWidth, pdfHeight);
    pdf.addImage(cedarLogo, "png", pdfWidth / 2, pdfHeight - 50, 100, 25);
    pdf.addImage(pdfRedirect, "png", pdfWidth - 50, pdfHeight - 45, 15, 15);
    pdf.textWithLink("Go to report", pdfWidth - 150, pdfHeight - 30, { url: window.location.href });
    pdf.save(`${fileName}.pdf`);

    dashboardDiv.style.height = "";

    if (pdfButton) pdfButton.style.display = "flex";

    if (window.location?.pathname?.includes("mtp_category")) {
      const items = document.getElementById("dashboard_items");
      items?.classList.remove("pdf_download");
      items?.classList.remove(`${multipleYrScenarios ? "multiple" : "one_yr_scnr_no_var"}`);
      items?.classList.remove(`${monthPeriod ? "month_period" : "quarter_period"}`);

      const db = document.getElementsByClassName("dashboard")[0];
      db?.classList.remove("pdf_download");
      db?.classList.remove(`${multipleYrScenarios ? "multiple" : "one_yr_scnr_no_var"}`);
      db?.classList.remove(`${monthPeriod ? "month_period" : "quarter_period"}`);

      const contentWrapper = document.getElementsByClassName("contentWrapper")[0];
      contentWrapper?.classList.remove("pdf_download");
      contentWrapper?.classList.remove(`${multipleYrScenarios ? "multiple" : "one_yr_scnr_no_var"}`);
      contentWrapper?.classList.remove(`${monthPeriod ? "month_period" : "quarter_period"}`);

      if (monthPeriod || multipleYrScenarios) {
        const table_2 = document.getElementsByClassName("table_2")[0];
        table_2?.classList.remove("pdf_download");

        const titles = document.getElementsByClassName("titles")[0];
        titles?.classList.remove("pdf_download");

        const tables = document.getElementsByClassName("tables")[0];
        tables?.classList.remove("pdf_download");

        const quarter_breakdown = document.getElementsByClassName("quarter_breakdown")[0];
        quarter_breakdown?.classList.remove("pdf_download");

        const mtp_category_table = document.getElementsByClassName("mtp_category_table")[0];
        mtp_category_table?.classList.remove("mtp_category_table");

        const combinedTables = document.getElementsByClassName("tablescombined")[0];
        combinedTables?.classList.remove("pdf_download");

        const pdf_tables = document.getElementsByClassName("pdf_tables")[0];
        pdf_tables?.classList.remove("pdf_download");
      }
    }

    eventTracking(MixpanelEvents.pdf_download, { filename: `${fileName}.pdf`, page: pageName, dashboard: pageName });
  });
};
